import Script from "next/script";

// const API_KEY = "AIzaSyAxUexG6jVxTbmcUej-KyFMd1kQuP3JGd0";
const API_KEY = "AIzaSyAhJHFaDPQ0gX1UYcsis20IUhaXsfSTNYQ";

const GooglePlaces = () => {
  return (
    <>
      <Script
        id="hs-script-settings"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              window.googleMapsCallback = (e) => {
                console.log(e)
              }`,
        }}
      />
      <Script
        strategy="lazyOnload"
        src={`https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places&loading=async&callback=googleMapsCallback`}
      />
    </>
  );
};

export default GooglePlaces;
